// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const fodselsnummer: CountryValidator<
  "NO",
  ParsedPersonId
> = createValidator("no.fodselsnummer", 137);

export default fodselsnummer;
export const compact = fodselsnummer.compact;
export const format = fodselsnummer.format;
export const validate = fodselsnummer.validate;
export const generate = (): string =>
  fodselsnummer.generate?.() ??
  (() => {
    throw new Error(
      "Validator no.fodselsnummer cannot generate values",
    );
  })();
export const parse = fodselsnummer.parse;
